// extracted by mini-css-extract-plugin
export default {"whatsappBtn":"WhatsappButton_whatsappBtn__QlEVu","icon":"WhatsappButton_icon__JK9RW","label":"WhatsappButton_label__454tA"};